import { Component, ViewEncapsulation } from '@angular/core';
import { DataCollectionStore } from './data-collection.store';

@Component({
    selector: 'app-data-collection-view',
    templateUrl: './data-collection-view.component.html',
    styleUrls: ['./data-collection-view.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
    providers: [DataCollectionStore]
})

export class DataCollectionViewComponent  {
    public selectedTabIndex: number = 0;

    constructor() {}

    public selectTab(index: number): void {
        this.selectedTabIndex = index;
    }
}
